import React, { useState, useEffect, useRef } from 'react'
import { useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
// import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux'
import { setLoading, setSnackInfo } from '../redux/actions/appAction';
import { Paper, Table, TableBody, TableCell, TableContainer, TableRow, TableHead, Divider, Typography, Accordion, AccordionSummary, AccordionDetails, Checkbox } from '@material-ui/core';
import { ROLENAME, LEADSTATUS, EXPCENTERID, LOCATIONID } from '../utils/index';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { commaSeparateAmount } from './commaSeparate';
import HttpService from '../services/httpService'
import moment from 'moment'
import { withStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select/Select';
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import Input from '@material-ui/core/Input';
import ListItemText from '@material-ui/core/ListItemText';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TablePagination from '@material-ui/core/TablePagination';
import { CSVLink } from "react-csv";
import CloseIcon from '@material-ui/icons/Close';
import GetAppIcon from '@material-ui/icons/GetApp';
import RefreshIcon from '@material-ui/icons/Refresh';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    tablealign: {
        display: "flex"
    },
    tablecontainer: {
        display: "flex",
        marginTop: "25px"
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightBold,
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
    table: {
        textAlign: 'center'
    },
    tableHeaderCell: {
        backgroundColor: '#f0f8ff',
        fontWeight: 'bold',
    },

}));
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const CalenderFilterData = (props) => {
    const classes = useStyles();
    const history = useHistory();
    const [leadsOnSelectedDate, setLeadsOnSelectedDate] = useState([]);
    const [salesStageLeadOnSelectedDate, setSalesStageLeadOnSelectedDate] = useState([]);
    const [canEdit, setCanEdit] = useState(props.editable)
    const { userDetails } = useSelector(state => state.user)
    const [locationExpCenter, setLocationExpCenter] = useState(props.locationExperienceCenterList);
    const [totalValue, setTotalValue] = useState(0)
    const [salesDataval, setSalesDataval] = useState([])
    const [sortedData, setSortedData] = useState([])
    const [totalCol, setTotalCol] = useState([]);
    const [rowTotal, setRowTotal] = useState([]);
    const [selectedExpcenters, setSelectedExpcenters] = useState([]);
    const [text, setText] = useState("Site/Office visit");
    const [decode, setDecode] = useState("")
    const [dumpExpCenters, setDumpExpcenters] = useState([]);
    const [TokenPercentage, setTokenPercentage] = useState("")
    const [leadStatusData, setLeadStatusData] = useState([])
    const [isStageDataVisible, setIsStageDataVisible] = useState(false);
    const [duplicateLeadStatusData, setDuplicateLeadStatusData] = useState([])
    const [selectedFilterOption, setSelectedFilterOption] = useState('');
    const [startDateFilter, setStartDate] = useState(props.selecteddate.start)
    const [endDateFilter, setEndDate] = useState(props.selecteddate.end);
    const [leadStatusDetails, setLeadStatusDetails] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);
    const [salesData, setSalesData] = useState([]);
    const [defaultExpCenter, setDefaultExpCenter] = useState(userDetails.selectedExpCenter);
    const [defaultExpCenterId, setDefaultExpCenterId] = useState(userDetails.selectedExpCenter);
    const [defaultCity, setDefaultCity] = useState(userDetails.selectedLocation);
    const [csvData, setCsvData] = useState([]);
    const [assignToList, setAssignToList] = useState([]);
    const [departmentStage, setDepartmentsStage] = useState([]);
    const [selectedAssignTo, setSelectedAssignTo] = useState([]);
    const [selectedStage, setSelectedStage] = useState([]);
    const [selectedUser, setSelectedUser] = useState("")
    const [selectedSalesId, setSelectedSalesId] = useState(null);
    const STAGE_DATA_TABLE_DISABLE_UNTIL_KEY = 'stageDataTable_disableUntil';
    const [isStageDataTableDisabled, setIsStageDataTableDisabled] = useState(false);
    const [stageDataTableTimeLeft, setStageDataTableTimeLeft] = useState(0);
    const buttonRef = useRef(null);
    const dataTableRef = useRef(null); // Reference for the data table
    const headers = [
        { key: "customerName", label: "Customer Name" },
        { key: "lead_no", label: "Lead No" },
        // { key: "email", label: "Email Id" },
        // { key: "contact_no", label: "Mobile No." },
        { key: 'salesStage', label: "salesStage" },
        { key: "lostReason", label: "Lost Reason" },
        { key: "address", label: "Address" },
        { key: "area", label: "Area" },
        { key: 'leadType', label: "Lead Type" },
        { key: "assignTo", label: 'Assign To' },
        { key: "estimatedBudget", label: 'Quotation Amount' },
        { key: "createdAt", label: 'Created At' },
    ];
    const [expandedStage, setExpandedStage] = useState(null);

    // Function to handle expanding/collapsing stage rows
    const toggleStageData = (stage) => {
        setExpandedStage((prevStage) => (prevStage === stage ? null : stage));
    };
    useEffect(() => {
        setCanEdit(props.editable)
        checkUserRole(props.role)
        setLocationExpCenter(props.locationExperienceCenterList)
        handleEncode();
        getLeadCountDetails(null,userDetails?._id, "");
        // yearWiseSlectedExpCenterData()
        getExperienceCenters();
        // eslint-disable-next-line
    }, [props, props.role])

    // Timer logic for Stage Data table
    useEffect(() => {
        // Check Stage Data table timer
        const stageDataDisableUntilTimestamp = localStorage.getItem(STAGE_DATA_TABLE_DISABLE_UNTIL_KEY);
        if (stageDataDisableUntilTimestamp) {
            const now = new Date().getTime();
            const disableUntil = parseInt(stageDataDisableUntilTimestamp, 10);

            if (disableUntil > now) {
                const remainingTimeInSeconds = Math.ceil((disableUntil - now) / 1000);
                setIsStageDataTableDisabled(true);
                setStageDataTableTimeLeft(remainingTimeInSeconds);
            } else {
                localStorage.removeItem(STAGE_DATA_TABLE_DISABLE_UNTIL_KEY);
                setIsStageDataTableDisabled(false);
                setStageDataTableTimeLeft(0);
            }
        }

        // Set up timer
        let stageDataTimer;
        if (isStageDataTableDisabled && stageDataTableTimeLeft > 0) {
            stageDataTimer = setInterval(() => {
                setStageDataTableTimeLeft((prevTime) => {
                    const newTime = prevTime - 1;
                    if (newTime <= 0) {
                        localStorage.removeItem(STAGE_DATA_TABLE_DISABLE_UNTIL_KEY);
                        setIsStageDataTableDisabled(false);
                        return 0;
                    }
                    return newTime;
                });
            }, 1000);
        }

        return () => {
            if (stageDataTimer) clearInterval(stageDataTimer);
        };
    }, [isStageDataTableDisabled, stageDataTableTimeLeft]);

    const handleEncode = () => {
        const encodedText = encodeURIComponent(text);
        setDecode(encodedText)
    };

    const checkUserRole = (roleid) => {
        if (roleid === ROLENAME.MarketingUser || roleid === ROLENAME.MarketingManager) {
            getLeadsOnSelectedDates(props.marketingdata);
        } else if ((roleid === ROLENAME.SalesManager || roleid === ROLENAME.DGM_Sales || roleid === ROLENAME.AssistantSalesManager || roleid === ROLENAME.SalesHead || roleid === ROLENAME.AGMSales)) {
            getSalesLeadOnSelectedDates(props.salesdata);
            //console.log(props.salesdata)
            ;
            var lastTotalValue = 0
            for (let i = 0; i < props.salesdata.length - 2; i++) {
                lastTotalValue += Number(props.salesdata[i].stage.Total)
            }
            setTotalValue(lastTotalValue)
        } else if (roleid === ROLENAME.SalesUser) {
            getSalesLeadOnSelectedDates(props.salesdata);
        } else {
            separeteLeadStatusWise(props.selectedUserDetails);
        }
    }


    const stages = [
        'Lead Received',
        'Requirements Not Collected', 
        'Requirements Collected',
        'Quotation Sent',
        'Site/Office visit',
        'Negotiation',
        'Won',
        'Won Deals Pending Designer Assignment',
        'Lost',
        'Delayed Requirement',
        'Total',
    ];

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };


    const handleStageClick = (stage, salesId, name) => {
        getLeadCountDetails(stage, salesId, name);

        // Scroll to the detailed data table
        if (dataTableRef.current) {
            dataTableRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };

    const getLeadCountDetails = async (stage, _id, name) => {
        // Scroll to the detailed data table
        if (dataTableRef.current) {
            dataTableRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }
        const obj = {
            startDate: startDateFilter,
            endDate: endDateFilter,
            filterOption: selectedFilterOption,
            experienceCenterId: props.selectedexpcenterid ? props.selectedexpcenterid : userDetails?.selectedExpCenter,
        };
        obj.assignTo = _id
        obj.stageStatus = stage === 'Site Office visit' ? 'Site/Office visit' : stage
        obj.status = 'salesuser'
        try {
            const response = await HttpService.getStatusWiseLeadData(obj);
            const filteredData = response?.data?.filter((item) =>
                item.assignTo.teamId.name.replace(/[\s+%/\\#,+$~.'":*?<>{}]/g, '') === stage.replace(/-/g, '')
            );
            const statusLead = response.data.map(item => {
                let obj = {
                    leadId: item?._id,
                    lead_no: item?.lead_no,
                    erpProjectNo: item?.erpProjectNo,
                    customerName: item?.customerId?.name,
                    customerId: item?.customerId?._id,
                    email: item?.customerId?.email,
                    // contact_no: item?.customerId?.contact_no,
                    address: item?.address,
                    area: item?.area,
                    salesStage: item?.salesStage,
                    currentStage: item?.currentStage,
                    lostReason: item?.salesStage === 'Lost' ? item?.reasonForLost : '-',
                    leadType: item?.leadType,
                    assignTo: item?.assignTo?.name,
                    estimatedBudget: item?.grandTotal,
                    createdAt: moment(item?.createdAt).format("DD-MM-YYYY"),
                    expectedSalesclosureDate: moment(item?.expectedSalesclosureDate).format("DD-MM-YYYY"),
                }
                return obj
            })
            // for sales users the data is being stored here
            setSelectedStage(stage);
            setSelectedUser(name);
            setSelectedSalesId(_id);
            setLeadStatusData(statusLead);
            setDuplicateLeadStatusData(statusLead);
            setCsvData(statusLead);
            setIsStageDataVisible(true);
        } catch (error) {
            console.error('Error fetching stage data:', error);
        }
    };

    const viewSelectedStageLeads = async (stage) => {
        const obj = {
            // startDate: startDateFilter,
            // endDate: endDateFilter,
            filterOption: selectedFilterOption,
            experienceCenterId: userDetails?.selectedExpCenter,
        };
        obj.salesStage = stage === 'Site Office visit' ? 'Site/Office visit' : stage
        // obj.status = 'salesuser'
        try {
            const response = await HttpService.getStageWiseLeadData(obj);
            // console.log(response.data,"data")
            // const filteredData = response?.data?.filter((item) =>
            //     item.assignTo.teamId.name.replace(/[\s+%/\\#,+$~.'":*?<>{}]/g, '') === stage.replace(/-/g, '')
            // );
            const statusLead = response.data.map(item => {
                let obj = {
                    leadId: item?._id,
                    lead_no: item?.lead_no,
                    erpProjectNo: item?.erpProjectNo,
                    customerName: item?.customerId?.name,
                    customerId: item?.customerId?._id,
                    // email: item?.customerId?.email,
                    // contact_no: item?.customerId?.contact_no,
                    address: item?.address,
                    area: item?.area,
                    salesStage: item?.salesStage,
                    currentStage: item?.currentStage,
                    lostReason: item?.salesStage === 'Lost' ? item?.reasonForLost : '-',
                    leadType: item?.leadType,
                    assignTo: item?.assignTo?.name,
                    estimatedBudget: item?.grandTotal,
                    createdAt: moment(item?.createdAt).format("DD-MM-YYYY"),
                    expectedSalesclosureDate: moment(item?.expectedSalesclosureDate).format("DD-MM-YYYY"),
                }
                return obj
            })
            setSelectedStage(stage);
            setSelectedUser("");
            setSelectedSalesId(null);
            setLeadStatusData(statusLead);
            setDuplicateLeadStatusData(statusLead);
            setCsvData(statusLead);
            setIsStageDataVisible(true);
        } catch (error) {
            console.log('Error fetching stage data:', error);
        }
    };

    const getLeadsOnSelectedDates = async (data) => {
        let finalData = [];
        Object.keys(data).forEach(function (key) {
            if (props.selectedexpcenter !== 'All') {
                var value = data[props.selectedexpcenter];
                separeteLeadStatusWise(value);
            } else {
                locationExpCenter.forEach((ele, i) => {
                    if (ele.name === key) {
                        finalData.push({
                            expcenter: key,
                            data: data[key]
                        })
                        separeteLeadStatusWise(finalData);
                    }
                })
            }
        });
    }

    const getSalesLeadOnSelectedDates = async (data) => {
        separeteLeadStatusWise(data);
    }

    const [finalStatusData1, setFinalStatusData] = useState([]);

    const separeteLeadStatusWise = (data) => {
        // if (data.length === 0) {
        //     setLeadsOnSelectedDate([])
        // }
        if (props.role === ROLENAME.MarketingManager || props.role === ROLENAME.MarketingUser) {
            if (props.selectedexpcenter !== 'All') {
                let centerList = [];
                centerList.push({
                    expcenter: props.selectedexpcenter
                })
                setLeadsOnSelectedDate(centerList)

                let leadStatus = [];
                leadStatus.push(
                    { name: LEADSTATUS.RealLead },
                    { name: LEADSTATUS.JunkLead },
                    { name: LEADSTATUS.HoldLead },
                    { name: LEADSTATUS.TBCLead },
                    { name: LEADSTATUS.TotalLeadsGenerated },
                    { name: 'sales' }
                )

                let finalStatusData = [];
                let teamData = [];
                for (let j = 0; j < leadStatus.length; j++) {
                    let obj1 = {};
                    if (leadStatus[j].name === 'Real') {
                        obj1.name = 'Real';
                        obj1[props.selectedexpcenter] = data?.realLeadCount ? data?.realLeadCount : `0`
                    }
                    if (leadStatus[j].name === 'Junk') {
                        obj1.name = 'Junk';
                        obj1[props.selectedexpcenter] = data?.junkLeadCount
                    }
                    if (leadStatus[j].name === 'Hold') {
                        obj1.name = 'Hold';
                        obj1[props.selectedexpcenter] = data?.onHoldCount
                    }
                    if (leadStatus[j].name === 'To Be Called') {
                        obj1.name = 'To Be Called';
                        obj1[props.selectedexpcenter] = data?.toBeCalledCount
                    }
                    if (leadStatus[j].name === 'Total Leads Generated') {
                        obj1.name = 'Total Leads Generated';
                        obj1[props.selectedexpcenter] = data?.totalLeadsGenerated
                    }
                    if (leadStatus[j].name === 'sales') {
                        obj1.name = 'Sales';
                        let totalSalesTeamCount = 0;
                        for (let k = 0; k < data?.teamsAssignedCount.length; k++) {
                            if (data?.teamsAssignedCount[k].hasOwnProperty('leadCount')) {
                                totalSalesTeamCount += data?.teamsAssignedCount[k].leadCount;
                                obj1[props.selectedexpcenter] = isNaN(totalSalesTeamCount) ? `0` : totalSalesTeamCount;
                            }
                            if (data?.teamsAssignedCount[k].leadCount !== undefined) {
                                let ss = {
                                    leadCount: data?.teamsAssignedCount[k].leadCount,
                                    name: data?.teamsAssignedCount[k].teamName,
                                    teamId: data?.teamsAssignedCount[k]._id,
                                    expcenter: props.selectedexpcenter
                                }
                                teamData.push(ss)
                            }
                        }
                    }
                    finalStatusData.push(obj1);
                }
                let teamArr = [];
                teamData.forEach((ele) => {
                    let total = 0;
                    let finalObj = {
                        name: ele.name,
                        teamId: ele.teamId,
                        Gachibowli: ele.expcenter === 'Gachibowli' ? total += ele.leadCount : `0`,
                        HSR: ele.expcenter === 'HSR' ? total += ele.leadCount : `0`,
                        Whitefield: ele.expcenter === 'Whitefield' ? total += ele.leadCount : `0`
                    }
                    teamArr.push(finalObj);
                })
                let myFinal = [...finalStatusData, ...teamArr]
                setFinalStatusData(myFinal);
            } else {
                let data1 = []
                let centers = []
                data.forEach(ele => {
                    centers.push(ele.expcenter)
                    data1.push({
                        expcenter: ele.expcenter,
                        'Real': ele?.data?.realLeadCount,
                        'Junk': ele?.data?.junkLeadCount,
                        'Hold': ele?.data?.onHoldCount,
                        'To Be Called': ele?.data?.toBeCalledCount,
                        'Total Leads Generated': ele?.data?.totalLeadsGenerated,
                        'sales': ele?.data?.teamsAssignedCount
                    })
                    setLeadsOnSelectedDate(data1.sort((a, b) => a.expcenter.localeCompare(b.expcenter)))
                })
                let leadStatus = [];

                leadStatus.push(
                    { name: LEADSTATUS.RealLead },
                    { name: LEADSTATUS.JunkLead },
                    { name: LEADSTATUS.HoldLead },
                    { name: LEADSTATUS.TBCLead },
                    { name: LEADSTATUS.TotalLeadsGenerated },
                    { name: 'sales' }
                )
                let finalStatusData = [];
                let teamData = [];
                for (let j = 0; j < leadStatus.length; j++) {
                    let obj1 = {};

                    for (let i = 0; i < data1.length; i++) {
                        if (leadStatus[j].name === 'Real') {
                            obj1.name = 'Real';
                            obj1[data1[i].expcenter] = data1[i]['Real']
                        }
                        if (leadStatus[j].name === 'Junk') {
                            obj1.name = 'Junk';
                            obj1[data1[i].expcenter] = data1[i]['Junk']
                        }
                        if (leadStatus[j].name === 'Hold') {
                            obj1.name = 'Hold';
                            obj1[data1[i].expcenter] = data1[i]['Hold']
                        }
                        if (leadStatus[j].name === 'To Be Called') {
                            obj1.name = 'To Be Called';
                            obj1[data1[i].expcenter] = data1[i]['To Be Called']
                        }
                        if (leadStatus[j].name === 'Total Leads Generated') {
                            obj1.name = 'Total Leads Generated';
                            obj1[data1[i].expcenter] = data1[i]['Total Leads Generated']
                        }

                        if (leadStatus[j].name === 'sales') {
                            obj1.name = 'Sales';
                            let totalSalesTeamCount = 0;
                            for (let k = 0; k < data1[i]['sales'].length; k++) {
                                if (data1[i]['sales'][k].hasOwnProperty('leadCount')) {
                                    totalSalesTeamCount += data1[i]['sales'][k].leadCount;
                                    obj1[data1[i].expcenter] = isNaN(totalSalesTeamCount) ? `0` : totalSalesTeamCount;
                                }
                                if (data1[i]['sales'][k].leadCount !== undefined) {
                                    let ss = {
                                        leadCount: data1[i]['sales'][k].leadCount,
                                        name: data1[i]['sales'][k].teamName,
                                        teamId: data1[i]['sales'][k]._id,
                                        expcenter: data1[i].expcenter
                                    }
                                    teamData.push(ss)
                                }
                            }
                        }
                    }
                    finalStatusData.push(obj1);
                }

                let teamArr = [];
                teamData.forEach((ele) => {
                    let total = 0;
                    let finalObj = {
                        name: ele.name,
                        teamId: ele.teamId,
                        Gachibowli: ele.expcenter === 'Gachibowli' ? total += ele.leadCount : `0`,
                        HSR: ele.expcenter === 'HSR' ? total += ele.leadCount : `0`,
                        Whitefield: ele.expcenter === 'Whitefield' ? total += ele.leadCount : `0`
                    }
                    teamArr.push(finalObj);
                })
                let myFinal = [...finalStatusData, ...teamArr]
                setFinalStatusData(myFinal);
            }
        }

        if (props.role === ROLENAME.SalesManager || props.role === ROLENAME.DGM_Sales || props.role === ROLENAME.AssistantSalesManager || props.role === ROLENAME.SalesHead || props.role === ROLENAME.AGMSales) {
            let finalData = [];
            let stagesFinalData = [];
            for (let j = 0; j < data.length; j++) {
                let obj = {};
                obj.salesUser = data[j].name;
                obj.salesId = data[j].userId;
                let statusNamesList = []

                Object.keys(data[j]).forEach(st => {
                    statusNamesList.push(st)
                })

                if (data[j]['name'] !== 'topInfo') {
                    for (let i = 0; i < statusNamesList.length; i++) {
                        if (statusNamesList[i] !== 'stage') {
                            let views = data[j][statusNamesList[i]]
                            if (typeof (views) === 'object') {
                                obj[statusNamesList[i]] = {
                                    value: data[j][statusNamesList[i]].value,
                                    count: data[j][statusNamesList[i]].count
                                }
                            }
                        }
                    }
                    finalData.push(obj)
                }

                // Stage data
                let stageObj = {};
                stageObj.name = data[j].name;
                stageObj.salesId = data[j].userId;
                stageObj.stages = data[j].stage;
                stageObj.teamId = data[j].teamId;
                if (stageObj.name !== undefined && stageObj.salesId !== undefined) {
                    stagesFinalData.push(stageObj)
                }
            }
            let stageCountFinal = [];
            let stageCount = {};
            stageCount.name = 'Total';
            stageCount.stages = {}
            stageCount.stages['Lead Received'] = 0;
            stageCount.stages['Requirements Not Collected'] = 0;
            stageCount.stages['Requirements Collected'] = 0;
            stageCount.stages['Quotation Sent'] = 0;
            stageCount.stages['Site/Office visit'] = 0;
            stageCount.stages['Negotiation'] = 0;
            stageCount.stages['Won'] = 0;
            stageCount.stages['Won Deals Pending Designer Assignment'] = 0;
            stageCount.stages['Lost'] = 0;
            stageCount.stages['Delayed Requirement'] = 0;
            stagesFinalData.forEach((ele, i) => {
                stageCount.stages['Lead Received'] += ele.stages['Lead Received'];
                stageCount.stages['Requirements Not Collected'] += ele.stages['Requirements Not Collected'];
                stageCount.stages['Requirements Collected'] += ele.stages['Requirements Collected'];
                stageCount.stages['Quotation Sent'] += ele.stages['Quotation Sent'];
                stageCount.stages['Site/Office visit'] += ele.stages['Site/Office visit'];
                stageCount.stages['Negotiation'] += ele.stages['Negotiation'];
                stageCount.stages['Won'] += ele.stages['Won'];
                stageCount.stages['Won Deals Pending Designer Assignment'] += ele.stages['Won Deals Pending Designer Assignment'];
                stageCount.stages['Lost'] += ele.stages['Lost'];
                stageCount.stages['Delayed Requirement'] += ele.stages['Delayed Requirement'];
            })
            stageCountFinal.push(stageCount)
            let finalStageCountAndStages = [...stagesFinalData, ...stageCountFinal];
            setLeadsOnSelectedDate(finalData)
            setSalesStageLeadOnSelectedDate(finalStageCountAndStages)
        }

        if (props.role === ROLENAME.SalesUser) {
            let statusNames = []
            Object.keys(data).forEach(st => {
                statusNames.push(st)
            })
            let finalData = [];
            let stageFinalData = [];
            for (let i = 0; i < statusNames.length; i++) {
                if (statusNames[i] !== 'stage') {
                    let views = data[statusNames[i]]
                    if (statusNames[i] !== 'info') {
                        finalData.push({
                            'status': statusNames[i],
                            'value': views.value,
                            'count': views.count
                        })
                    }
                }
            }
            setLeadsOnSelectedDate(finalData)

            // Stage data
            stageFinalData.push({
                stages: data.stage
            })
            setSalesStageLeadOnSelectedDate(stageFinalData)
        }
    }

    const changePageRoute = (data, centerId) => {
        console.log(centerId, 'center name', props.selectedexpcenter === 'All');
        if (props.selectedexpcenter === 'All') {
            if (data.teamId) {
                history.push(`/status-information/${data.name.replace(/[\s+%/\\#,+$~.'":*?<>{}]/g, '-')}/${props.selecteddate.start}/${props.selecteddate.end}/${data.teamId}/false`, {
                    experienceCenterId: centerId,
                    locationId: props.selectedlocationid
                });
            } else {
                history.push(`/status-information/${data.name.replace(/[\s+%/\\#,+$~.'":*?<>{}]/g, '-')}/${props.selecteddate.start}/${props.selecteddate.end}/status/false`, {
                    experienceCenterId: centerId,
                    locationId: props.selectedlocationid
                });
            }
        } else {
            if (data.teamId) {
                history.push(`/status-information/${data.name.replace(/[\s+%/\\#,+$~.'":*?<>{}]/g, '-')}/${props.selecteddate.start}/${props.selecteddate.end}/${data.teamId}/false`, {
                    experienceCenterId: props.selectedexpcenterid,
                    locationId: props.selectedlocationid
                });
            } else {
                history.push(`/status-information/${data.name.replace(/[\s+%/\\#,+$~.'":*?<>{}]/g, '-')}/${props.selecteddate.start}/${props.selecteddate.end}/status/false`, {
                    experienceCenterId: props.selectedexpcenterid,
                    locationId: props.selectedlocationid
                });
            }
        }
    }

    const changeSalesPageRoute = (data, status, user) => {
        if (props.role === ROLENAME.SalesManager || props.role === ROLENAME.DGM_Sales || props.role === ROLENAME.AssistantSalesManager) {
            if (user !== 'NA') {
                history.push(`/status-information/${status}/${props.selecteddate.start}/${props.selecteddate.end}/status/${user}`, {
                    experienceCenterId: props.selectedexpcenterid,
                    locationId: props.selectedlocationid,
                    filterOption: props.filteroption
                });
            } else {
                history.push(`/status-information/${status}/${props.selecteddate.start}/${props.selecteddate.end}/status/${user}`, {
                    experienceCenterId: props.selectedexpcenterid,
                    locationId: props.selectedlocationid,
                    filterOption: props.filteroption,
                });
            }
        } else {
            history.push(`/status-information/${data.status}/${props.selecteddate.start}/${props.selecteddate.end}/status/${userDetails._id}`, {
                experienceCenterId: props.selectedexpcenterid,
                locationId: props.selectedlocationid,
                filterOption: props.filteroption
            });
        }
    }

    const changeSalesStagePageRoute = (stage, teamId, assignToStatus) => {
        if (stage === 'Won Deals Pending Designer Assignment') {
            history.push(`/designer-assignment/Won-Deals-Pending-Designer-Assignment/${props.selecteddate.start}/${props.selecteddate.end}/${teamId}/user`, {
                experienceCenterId: props.selectedexpcenterid,
                locationId: props.selectedlocationid,
                filterOption: props.filteroption
            });
        } else if (props.role === ROLENAME.DGM_Sales) {
            history.push(`/status-information/${stage}/${props.selecteddate.start}/${props.selecteddate.end}/salesHead/${teamId}`, {
                experienceCenterId: props.selectedexpcenterid,
                locationId: props.selectedlocationid,
                filterOption: props.filteroption
            });
        } else {
            history.push(`/status-information/${stage}/${props.selecteddate.start}/${props.selecteddate.end}/salesuser/${teamId}`, {
                experienceCenterId: props.selectedexpcenterid,
                locationId: props.selectedlocationid,
                filterOption: props.filteroption
            });
        }
    }

    const downloadExcel = () => {
        props.setLoading(true)
        try {
            setTimeout(() => {
                buttonRef.current.link.click();
            });
        } catch (err) {
            console.error(err.message);
        }
        props.setLoading(false)
    }

    const viewSelectedStageLeadss = (stage) => {
        history.push(`/Sales-lead-wise-total-data`, {
            experienceCenterId: props.selectedexpcenterid,
            salesStage: stage,
            locationId: props.selectedlocationid,
            filterOption: props.filteroption,
            startDate: props.selecteddate.start,
            endDate: props.selecteddate.end
        });
    }


    // const yearWiseSlectedExpCenterData = async () => {
    //     try {
    //         let exparr = []
    //         let dataquery = {}
    //         exparr.push(userDetails.selectedExpCenter)
    //         dataquery.experienceCenterId = exparr
    //         const response = await HttpService.yearWiseSlectedExpCenterData(dataquery)
    //         setSalesDataval(response.data);
    //         let newarray = []
    //         let grandTotal = 0;
    //         let grandcount = 0;
    //         for (let i = 0; i < response.data.length; i++) {
    //             let total = 0
    //             let count = 0
    //             for (let j = 0; j < response.data[i].length; j++) {

    //                 total += response.data[i][j].totalValue
    //                 count += response.data[i][j].count

    //             }
    //             grandTotal += total;
    //             grandcount += count
    //             newarray.push({
    //                 total: total,
    //                 count: count
    //             })
    //         }
    //         newarray.push({
    //             total: grandTotal,
    //             count: grandcount
    //         })
    //         setTotalCol(newarray)

    //         let array = []
    //         for (let i = 0; i < response.data.length; i++) {
    //             let sortedDates = response.data[i].sort((p1, p2) => (p1.prio > p2.prio) ? 1 : (p1.prio < p2.prio) ? -1 : 0);
    //             let sortedTeams = sortedDates.sort((p1, p2) => (p1.teamId > p2.teamId) ? 1 : (p1.teamId < p2.teamId) ? -1 : 0);


    //             let totalValue = 0;
    //             let totalCount = 0
    //             for (let i = 0; i < sortedTeams.length; i++) {
    //                 if (sortedTeams[i].roles[0] === "Sales User") {
    //                     totalValue += sortedTeams[i].totalValue
    //                     totalCount += sortedTeams[i].count
    //                 } else if (sortedTeams[i].roles[0] === "Sales Manager") {
    //                     sortedTeams[i].totalValue += totalValue
    //                     sortedTeams[i].count += totalCount
    //                     totalValue = 0
    //                     totalCount = 0
    //                 }
    //             }
    //             array.push(sortedTeams)
    //         }

    //         let rowCount = countData(array)
    //         let rowValue = ValueData(array)
    //         let rowTotal = []
    //         for (let k = 0; k < rowCount.length; k++) {
    //             rowTotal.push(
    //                 {
    //                     count: rowCount[k],
    //                     value: rowValue[k]
    //                 }
    //             )
    //         }
    //         setRowTotal(rowTotal)
    //         setSortedData(array)

    //     } catch (error) {
    //         console.log(error)
    //     }
    // }

    const countData = (array) => {
        const newArray = [];
        array.forEach(sub => {
            sub.forEach((num, index) => {
                if (newArray[index]) {
                    newArray[index] += num.count;
                } else {
                    newArray[index] = num.count;
                }
            });
        });
        return newArray;
    }

    const ValueData = (array) => {
        const newArray = [];
        array.forEach(sub => {
            sub.forEach((num, index) => {
                if (newArray[index]) {
                    newArray[index] += num.totalValue;
                } else {
                    newArray[index] = num.totalValue;
                }
            });
        });
        return newArray;
    }

    const getSelectedExpCenters = (e) => {
        setSelectedExpcenters(e.target.value);
    }

    const getExperienceCenters = async () => {
        props.setLoading(true)
        try {
            const response = await HttpService.getExpericenCenters()
            setDumpExpcenters(response.data)
        } catch (error) {
            props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", "error")
        }
        props.setLoading(false)
    }
    const [checked, setChecked] = useState(false);

    const toggleChecked = () => {
        setChecked((prev) => !prev);
    };

    // const applyFilter = async () => {
    //     let selectedCenter = [];
    //     let query = {}
    //     if (selectedExpcenters.length !== 0) {
    //         dumpExpCenters.forEach((ele, i) => {
    //             if (selectedExpcenters.includes(ele.name)) {
    //                 selectedCenter.push(ele._id)
    //             }
    //         })
    //         query.experienceCenterId = selectedCenter
    //     }else if(selectedExpcenters.length === 0){
    //         let exparr = []
    //         exparr.push(userDetails.selectedExpCenter)
    //         query.experienceCenterId = exparr
    //     }

    //     if(checked){
    //     query.TokenPercentage =  "Above-5%"
    //     }
    //     props.setLoading(true)
    //     try {
    //         const response = await HttpService.yearWiseSlectedExpCenterData(query)
    //         setSalesDataval(response.data);
    //         let newarray = []
    //         let grandTotal = 0;
    //         let grandcount = 0;
    //         for (let i = 0; i < response.data.length; i++) {
    //             let total = 0
    //             let count = 0
    //             for (let j = 0; j < response.data[i].length; j++) {

    //                 total += response.data[i][j].totalValue
    //                 count += response.data[i][j].count

    //             }
    //             grandTotal += total;
    //             grandcount += count
    //             newarray.push({
    //                 total: total,
    //                 count: count
    //             })
    //         }
    //         newarray.push({
    //             total: grandTotal,
    //             count: grandcount
    //         })
    //         setTotalCol(newarray)

    //         let array = []
    //         for (let i = 0; i < response.data.length; i++) {
    //             let sortedDates = response.data[i].sort((p1, p2) => (p1.prio > p2.prio) ? 1 : (p1.prio < p2.prio) ? -1 : 0);
    //             let sortedTeams = sortedDates.sort((p1, p2) => (p1.teamId > p2.teamId) ? 1 : (p1.teamId < p2.teamId) ? -1 : 0);


    //             let totalValue = 0;
    //             let totalCount = 0
    //             for (let i = 0; i < sortedTeams.length; i++) {
    //                 if (sortedTeams[i].roles[0] === "Sales User") {
    //                     totalValue += sortedTeams[i].totalValue
    //                     totalCount += sortedTeams[i].count
    //                 } else if (sortedTeams[i].roles[0] === "Sales Manager") {
    //                     sortedTeams[i].totalValue += totalValue
    //                     sortedTeams[i].count += totalCount
    //                     totalValue = 0
    //                     totalCount = 0
    //                 }
    //             }
    //             array.push(sortedTeams)
    //         }

    //         let rowCount = countData(array)
    //         let rowValue = ValueData(array)
    //         let rowTotal = []
    //         for (let k = 0; k < rowCount.length; k++) {
    //             rowTotal.push(
    //                 {
    //                     count: rowCount[k],
    //                     value: rowValue[k]
    //                 }
    //             )
    //         }
    //         setRowTotal(rowTotal)
    //         setSortedData(array)

    //     } catch (error) {
    //         props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", "error")
    //     }
    //     props.setLoading(false)

    // }
    const formatStageDataTableTimeLeft = () => {
        const minutes = Math.floor(stageDataTableTimeLeft / 60);
        const seconds = stageDataTableTimeLeft % 60;
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    };


    const handleRefreshStageData = async () => {
        // Calculate the timestamp 4 minutes from now
        const disableUntilTimestamp = new Date().getTime() + (4 * 60 * 1000);

        // Store the timestamp in localStorage
        localStorage.setItem(STAGE_DATA_TABLE_DISABLE_UNTIL_KEY, disableUntilTimestamp.toString());

        // Disable the button for 4 minutes
        setIsStageDataTableDisabled(true);
        setStageDataTableTimeLeft(240); // 4 minutes in seconds

        props.setLoading(true);
        try {
            // Determine experienceCenterId based on role and props
            let experienceCenterId;
            if (props.role === ROLENAME.SalesHead || props.role === ROLENAME.DGM_Sales) {
                // For SalesHead/DGM_Sales, experienceCenterId should be an array
                if (Array.isArray(props.selectedexpcenterid)) {
                    experienceCenterId = props.selectedexpcenterid;
                } else if (props.selectedexpcenterid) {
                    experienceCenterId = [props.selectedexpcenterid];
                } else {
                    experienceCenterId = [];
                }
            } else {
                // For other roles, can be single value or array
                experienceCenterId = props.selectedexpcenterid || userDetails?.selectedExpCenter;
            }
            let formattedExpCenterId = experienceCenterId;
            if (Array.isArray(experienceCenterId)) {
                formattedExpCenterId = experienceCenterId.join(',');
            }

            const data = {
                startDate: startDateFilter,
                endDate: endDateFilter,
                experienceCenterId: formattedExpCenterId,
                filterOption: selectedFilterOption || props.filteroption || 'createdAt'
            };

            // Fetch fresh data from API
            const response = await HttpService.getSalesLeadOnSelectedDate(data);
            
            if (response && response.status === 200 && response.data) {
                // Process the fresh data
                separeteLeadStatusWise(response.data);
                props.setSnackInfo('Stage data refreshed successfully', "success");
            } else {
                // Fallback to re-processing existing data if API fails
                if (props.salesdata) {
                    separeteLeadStatusWise(props.salesdata);
                    props.setSnackInfo('Using cached data. Please try again.', "info");
                } else {
                    props.setSnackInfo('No data available to refresh', "warning");
                }
            }
        } catch (error) {
            console.error('Error refreshing stage data:', error);
            // Fallback to re-processing existing data if API fails
            if (props.salesdata) {
                separeteLeadStatusWise(props.salesdata);
                props.setSnackInfo('Error fetching fresh data. Using cached data.', "warning");
            } else {
                props.setSnackInfo('Error refreshing stage data', "error");
            }
        } finally {
            props.setLoading(false);
        }
    };

    const clearFilter = () => {
        setSelectedExpcenters([])
        setTokenPercentage("")
    }

    return (
        <div>
            {/* Section for Select Date */}
            <div style={{ marginTop: 25, marginBottom: 25 }}>


                {/* Section for to show the records on selected date */}
                {
                    (props.role === ROLENAME.MarketingManager || props.role === ROLENAME.MarketingUser) &&
                    <Paper className={classes.paper}>
                        <TableContainer component={Paper} >
                            <Table className={classes.table} size="small" stickyHeader aria-label="sticky table">
                                <TableHead style={{ textAlign: 'center' }}>
                                    <TableRow>
                                        <TableCell align="center">Status</TableCell>
                                        {
                                            leadsOnSelectedDate.map((row, i) => {
                                                return (
                                                    <TableCell align="center">{row.expcenter}</TableCell>
                                                )
                                            })
                                        }
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        finalStatusData1.map((status, i) => {
                                            return (
                                                <TableRow>
                                                    <TableCell component="th" scope="row" style={{ fontWeight: status.name === 'Sales' ? 700 : 0, padding: 10, width: 500, textAlign: 'center' }} >
                                                        {status.name}
                                                    </TableCell>
                                                    {
                                                        (props.selectedexpcenter === 'All' && props.selectedLocation === LOCATIONID.bangalore) && <>

                                                            <TableCell component="th" scope="row" style={{ fontWeight: status.name === 'Sales' ? 700 : 0, padding: 10, width: 500, textAlign: 'center' }}>
                                                                {
                                                                    status.name !== 'Sales' && canEdit === true && status.Whitefield !== 0 ?
                                                                        <Button onClick={() => changePageRoute(status, EXPCENTERID.whiltefield)} color="primary">
                                                                            {(status.Whitefield !== 'undefined' || status.Whitefield !== '') && status.hasOwnProperty('Whitefield') ? status.Whitefield : `0`}
                                                                        </Button>
                                                                        :
                                                                        <> {(status.Whitefield !== 'undefined' || status.Whitefield !== '') && status.hasOwnProperty('Whitefield') ? status.Whitefield : `0`} </>
                                                                }
                                                            </TableCell>
                                                            <TableCell component="th" scope="row" style={{ fontWeight: status.name === 'Sales' ? 700 : 0, padding: 10, width: 500, textAlign: 'center' }}>
                                                                {
                                                                    status.name !== 'Sales' && canEdit === true && status.HSR !== 0 ?
                                                                        <Button onClick={() => changePageRoute(status, EXPCENTERID.hsr)} color="primary">
                                                                            {(status.HSR !== 'undefined' || status.HSR !== '') && status.hasOwnProperty('HSR') ? status.HSR : `0`}
                                                                        </Button>
                                                                        :
                                                                        <> {(status.HSR !== 'undefined' || status.HSR !== '') && status.hasOwnProperty('HSR') ? status.HSR : `0`} </>
                                                                }
                                                            </TableCell>
                                                        </>
                                                    }
                                                    {
                                                        (props.selectedexpcenter === 'All' && props.selectedLocation === LOCATIONID.hyderabad) && <>
                                                            <TableCell component="th" scope="row" style={{ fontWeight: status.name === 'Sales' ? 700 : 0, padding: 10, width: 500, textAlign: 'center' }}>
                                                                {
                                                                    status.name !== 'Sales' && canEdit === true && status.Gachibowli !== 0 ?
                                                                        <Button onClick={() => changePageRoute(status, EXPCENTERID.Gachibowli)} color="primary">
                                                                            {(status.Gachibowli !== 'undefined' || status.Gachibowli !== '') && status.hasOwnProperty('Gachibowli') ? status.Gachibowli : `0`}
                                                                        </Button>
                                                                        :
                                                                        <> {(status.Gachibowli !== 'undefined' || status.Gachibowli !== '') && status.hasOwnProperty('Gachibowli') ? status.Gachibowli : `0`} </>
                                                                }
                                                            </TableCell>
                                                        </>
                                                    }

                                                    {
                                                        props.selectedexpcenter === 'HSR' &&
                                                        <TableCell component="th" scope="row" style={{ fontWeight: status.name === 'Sales' ? 700 : 0, padding: 10, width: 500, textAlign: 'center' }}>
                                                            {
                                                                status.name !== 'Sales' && canEdit === true && status.HSR !== 0 ?
                                                                    <Button onClick={() => changePageRoute(status, EXPCENTERID.hsr)} color="primary">
                                                                        {(status.HSR !== 'undefined' || status.HSR !== '') && status.hasOwnProperty('HSR') ? status.HSR : `0`}
                                                                    </Button>
                                                                    :
                                                                    <> {(status.HSR !== 'undefined' || status.HSR !== '') && status.hasOwnProperty('HSR') ? status.HSR : `0`} </>
                                                            }
                                                        </TableCell>
                                                    }

                                                    {
                                                        props.selectedexpcenter === 'Whitefield' &&

                                                        <TableCell component="th" scope="row" style={{ fontWeight: status.name === 'Sales' ? 700 : 0, padding: 10, width: 500, textAlign: 'center' }}>
                                                            {
                                                                status.name !== 'Sales' && canEdit === true && status.Whitefield !== 0 ?
                                                                    <Button onClick={() => changePageRoute(status, EXPCENTERID.Whitefield)} color="primary">
                                                                        {(status.Whitefield !== 'undefined' || status.Whitefield !== '') && status.hasOwnProperty('Whitefield') ? status.Whitefield : `0`}
                                                                    </Button>
                                                                    :
                                                                    <> {(status.Whitefield !== 'undefined' || status.Whitefield !== '') && status.hasOwnProperty('Whitefield') ? status.Whitefield : `0`} </>
                                                            }
                                                        </TableCell>
                                                    }
                                                    {
                                                        props.selectedexpcenter === 'Gachibowli' &&

                                                        <TableCell component="th" scope="row" style={{ fontWeight: status.name === 'Sales' ? 700 : 0, padding: 10, width: 500, textAlign: 'center' }}>
                                                            {
                                                                status.name !== 'Sales' && canEdit === true && status.Gachibowli !== 0 ?
                                                                    <Button onClick={() => changePageRoute(status, EXPCENTERID.Gachibowli)} color="primary">
                                                                        {(status.Gachibowli !== 'undefined' || status.Gachibowli !== '') && status.hasOwnProperty('Gachibowli') ? status.Gachibowli : `0`}
                                                                    </Button>
                                                                    :
                                                                    <> {(status.Gachibowli !== 'undefined' || status.Gachibowli !== '') && status.hasOwnProperty('Gachibowli') ? status.Gachibowli : `0`} </>
                                                            }
                                                        </TableCell>
                                                    }
                                                </TableRow>
                                            )
                                        })
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                }
                {
                    (props.role === ROLENAME.SalesManager || props.role === ROLENAME.DGM_Sales || props.role === ROLENAME.AssistantSalesManager || props.role === ROLENAME.SalesHead || props.role === ROLENAME.AGMSales) && <>
                        {/* Status wise data for all Sales Executive */}
                        {/* <Paper className={classes.paper}>
                            <Accordion defaultExpanded>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography className={classes.heading}>
                                        {props.role === ROLENAME.SalesManager || props.role === ROLENAME.AssistantSalesManager ?
                                            `Team Member wise data (*Please select the "Lead Created At" option to see meaningful data)`
                                            :
                                            `All Sales executive data (*Please select the "Lead Created At" option to see meaningful data)`}
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails style={{ padding: 0 }}>
                                    <TableContainer component={Paper}>
                                        <Table className={classes.table} stickyHeader aria-label="sticky table">
                                            <TableHead>
                                                <TableRow >
                                                    <TableCell style={{ padding: 10, width: 500, textAlign: 'center', fontWeight: 700 }}>Sales Executive</TableCell>
                                                    <TableCell style={{ padding: 10, width: 500, textAlign: 'center', fontWeight: 700 }}>Won</TableCell>
                                                    <TableCell style={{ padding: 10, width: 500, textAlign: 'center', fontWeight: 700 }}>Lost</TableCell>
                                                    <TableCell style={{ padding: 10, width: 500, textAlign: 'center', fontWeight: 700 }}>Open</TableCell>
                                                    <TableCell style={{ padding: 10, width: 500, textAlign: 'center', fontWeight: 700 }}>Total</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {leadsOnSelectedDate.map((row, i) => {
                                                    return (
                                                        <TableRow key={i + 1}>
                                                            <TableCell component="th" scope="row" style={{ padding: 10, width: 500, textAlign: 'center' }}> {row?.salesUser} </TableCell>
                                                            <TableCell component="th" scope="row" style={{ padding: 10, width: 500, textAlign: 'center' }}>
                                                                {
                                                                    canEdit === true && row.hasOwnProperty('Won') && row?.salesUser !== 'Total' ?
                                                                        <Button onClick={() => changeSalesPageRoute(row.Won, 'Won', row?.salesId)} color="primary">
                                                                            {row.Won?.count} - (₹ {commaSeparateAmount(row.Won?.value)})
                                                                        </Button>
                                                                        :
                                                                        <Button onClick={() => changeSalesPageRoute(row.Won, 'Won', "NA")} color="primary">
                                                                            {row.Won?.count ? row.Won?.count : `0`} - (₹ {row.Won?.value ? commaSeparateAmount(row.Won?.value) : `0`})
                                                                        </Button>
                                                                }
                                                            </TableCell>
                                                            <TableCell component="th" scope="row" style={{ padding: 10, width: 500, textAlign: 'center' }}>
                                                                {
                                                                    canEdit === true && row.hasOwnProperty('Lost') && row?.salesUser !== 'Total' ?
                                                                        <Button onClick={() => changeSalesPageRoute(row.Lost, 'Lost', row?.salesId)} color="primary">
                                                                            {row.Lost?.count} - (₹ {commaSeparateAmount(row.Lost?.value)})
                                                                        </Button>
                                                                        :
                                                                        <Button onClick={() => changeSalesPageRoute(row.Lost, 'Lost',  "NA")} color="primary">
                                                                        {row.Lost?.count ? row.Lost?.count : `0`} - (₹ {row.Lost?.value ? commaSeparateAmount(row.Lost?.value) : `0`})
                                                                    </Button>
                                                                }
                                                            </TableCell>
                                                            <TableCell component="th" scope="row" style={{ padding: 10, width: 500, textAlign: 'center' }}>
                                                                {
                                                                    canEdit === true && row.hasOwnProperty('Open') && row?.salesUser !== 'Total' ?
                                                                        <Button onClick={(e) => changeSalesPageRoute(row.Open, 'Open', row?.salesId)} color="primary">
                                                                            {row.Open?.count} - (₹ {commaSeparateAmount(row.Open?.value)})
                                                                        </Button>
                                                                        :
                                                                        <Button onClick={(e) => changeSalesPageRoute(row.Open, 'Open', "NA")} color="primary">
                                                                            {row?.Open?.count ? row.Open?.count : `0`} - (₹ {row?.Open?.value ? commaSeparateAmount(row.Open?.value) : `0`})
                                                                        </Button>
                                                                }
                                                            </TableCell>
                                                            <TableCell component="th" scope="row" style={{ padding: 10, width: 500, textAlign: 'center' }}>
                                                                {
                                                                    canEdit === true && row.hasOwnProperty('salesUserTotal') && row?.salesUser !== 'Total' ?
                                                                        <Button onClick={(e) => changeSalesPageRoute(row.salesUserTotal, 'salesUserTotal', row?.salesId)} color="primary">
                                                                            {row.salesUserTotal?.count} - (₹ {commaSeparateAmount(row.salesUserTotal?.value)})
                                                                        </Button>
                                                                        :
                                                                        <Button onClick={(e) => changeSalesPageRoute(row.salesUserTotal, 'salesUserTotal',"NA")} color="primary">
                                                                            <> {row?.salesUserTotal?.count ? row.salesUserTotal?.count : `0`} - (₹ {row?.salesUserTotal?.value ? commaSeparateAmount(row.salesUserTotal?.value) : `0`}) </>
                                                                        </Button>
                                                                }
                                                            </TableCell>
                                                        </TableRow>
                                                    );
                                                })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </AccordionDetails>
                            </Accordion>
                        </Paper> */}

                        {/* Stage Wise Data for All Sales Executive */}
                        <Paper className={classes.paper} style={{ marginTop: 20 }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                                <Typography className={classes.heading}>
                                    Stage-wise data (No Date Filter)
                                </Typography>
                                <Button
                                    onClick={handleRefreshStageData}
                                    variant="contained"
                                    disabled={isStageDataTableDisabled}
                                    style={{ 
                                        backgroundColor: isStageDataTableDisabled ? "#cccccc" : "#F47E46", 
                                        color: "#FFFFFF",
                                        padding: "8px 16px"
                                    }}
                                    size="small"
                                >
                                    {isStageDataTableDisabled 
                                        ? `Wait (${formatStageDataTableTimeLeft()})` 
                                        : "Fetch New Data"}
                                </Button>
                            </div>
                            <TableContainer component={Paper}>
                                <Table className={classes.table} stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell style={{ padding: 8, width: 500, textAlign: 'center', fontWeight: 700, backgroundColor: '#f0f8ff', fontWeight: 'bold' }}>Sales Executive</TableCell>
                                            <TableCell style={{ padding: 8, width: 470, textAlign: 'center', fontWeight: 600, backgroundColor: '#f0f8ff', fontWeight: 'bold' }}>Lead Received</TableCell>
                                            <TableCell style={{ padding: 8, width: 470, textAlign: 'center', fontWeight: 600, backgroundColor: '#f0f8ff', fontWeight: 'bold' }}>Requirements Not Collected</TableCell>
                                            <TableCell style={{ padding: 8, width: 470, textAlign: 'center', fontWeight: 600, backgroundColor: '#f0f8ff', fontWeight: 'bold' }}>Requirements Collected</TableCell>
                                            <TableCell style={{ padding: 8, width: 470, textAlign: 'center', fontWeight: 600, backgroundColor: '#f0f8ff', fontWeight: 'bold' }}>Quotation Sent</TableCell>
                                            <TableCell style={{ padding: 8, width: 470, textAlign: 'center', fontWeight: 600, backgroundColor: '#f0f8ff', fontWeight: 'bold' }}>Site/Office visit</TableCell>
                                            <TableCell style={{ padding: 8, width: 470, textAlign: 'center', fontWeight: 600, backgroundColor: '#f0f8ff', fontWeight: 'bold' }}>Negotiation</TableCell>
                                            <TableCell style={{ padding: 8, width: 470, textAlign: 'center', fontWeight: 600, backgroundColor: '#f0f8ff', fontWeight: 'bold' }}>Won</TableCell>
                                            <TableCell style={{ padding: 8, width: 470, textAlign: 'center', fontWeight: 600, backgroundColor: '#f0f8ff', fontWeight: 'bold' }}>Won Deals Pending Designer Assignment</TableCell>
                                            <TableCell style={{ padding: 8, width: 470, textAlign: 'center', fontWeight: 600, backgroundColor: '#f0f8ff', fontWeight: 'bold' }}>Lost</TableCell>
                                            <TableCell style={{ padding: 8, width: 470, textAlign: 'center', fontWeight: 600, backgroundColor: '#f0f8ff', fontWeight: 'bold' }}>Delayed Requirement</TableCell>
                                            <TableCell style={{ padding: 8, width: 470, textAlign: 'center', fontWeight: 600, backgroundColor: '#f0f8ff', fontWeight: 'bold' }}>Total</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {salesStageLeadOnSelectedDate.map((row, i) => (
                                            <TableRow key={i}>
                                                <TableCell component="th" scope="row" style={{ padding: 10, textAlign: "center" }}>
                                                    {row?.name}
                                                </TableCell>
                                                {stages.map((stage) => (
                                                    <TableCell
                                                        key={stage}
                                                        component="th"
                                                        scope="row"
                                                        style={{ padding: 10, textAlign: "center" }}
                                                    >
                                                        {canEdit === true && row?.name !== "Total" ? (
                                                            <Button
                                                                onClick={() =>
                                                                    getLeadCountDetails(
                                                                        stage === "Total" ? "salesTotal" : stage,
                                                                        row?.salesId,
                                                                        row?.name
                                                                    )
                                                                }
                                                                color="primary"
                                                            >
                                                                {row?.stages?.[stage] || "0"}
                                                            </Button>
                                                        ) : (
                                                            <Button onClick={() => viewSelectedStageLeads(stage)} color="primary">
                                                                {row.stages[stage] || "0"}
                                                            </Button>
                                                        )}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            {isStageDataVisible && leadStatusData.length > 0 && (
                                <div ref={dataTableRef} style={{ marginTop: 20, marginBottom: 20 }}>
                                    <Paper>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 20px', flexWrap: 'nowrap' }}>
                                            <Typography variant="h6" className={classes.heading} style={{ whiteSpace: 'nowrap' }}>
                                                Table View for Stage: {selectedStage} of {selectedUser}
                                            </Typography>
                                            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                                <Button
                                                    onClick={downloadExcel}
                                                    variant="contained"
                                                    color="primary"
                                                    startIcon={<GetAppIcon />}
                                                >
                                                    Download
                                                </Button>
                                                <Button
                                                    variant="contained"
                                                    color="secondary"
                                                    onClick={() => setIsStageDataVisible(false)}
                                                    startIcon={<CloseIcon />}
                                                >
                                                    Close
                                                </Button>
                                                <TablePagination
                                                    rowsPerPageOptions={[100, 200, 400, { label: 'All', value: leadStatusData?.length }]}
                                                    colSpan={14}
                                                    count={leadStatusData?.length}
                                                    rowsPerPage={rowsPerPage}
                                                    page={page}
                                                    SelectProps={{
                                                        inputProps: { 'aria-label': 'rows per page' },
                                                        native: true,
                                                    }}
                                                    onPageChange={handleChangePage}
                                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                                    style={{ flexShrink: 0 }}
                                                />
                                            </div>
                                            <CSVLink
                                                headers={headers}
                                                filename={selectedStage.replace(/-/g, ' ') + '.csv'}
                                                data={csvData}
                                                ref={buttonRef}
                                                style={{ display: 'none' }} // Keeps it functional but hidden
                                            />
                                        </div>
                                        <Divider />
                                        <TableContainer component={Paper}>
                                            <Table className={classes.table} stickyHeader aria-label="sticky table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell className={classes.tableHeaderCell}>Sl No.</TableCell>
                                                        <TableCell className={classes.tableHeaderCell}>Customer</TableCell>
                                                        <TableCell className={classes.tableHeaderCell}>Lead No</TableCell>
                                                        <TableCell className={classes.tableHeaderCell}>Project No.</TableCell>
                                                        <TableCell className={classes.tableHeaderCell}>Current Stage</TableCell>
                                                        <TableCell className={classes.tableHeaderCell}>Email</TableCell>
                                                        <TableCell className={classes.tableHeaderCell}>Mobile</TableCell>
                                                        <TableCell className={classes.tableHeaderCell}>Address</TableCell>
                                                        <TableCell className={classes.tableHeaderCell}>Area</TableCell>
                                                        <TableCell className={classes.tableHeaderCell}>Lead Type</TableCell>
                                                        <TableCell className={classes.tableHeaderCell}>Assigned to</TableCell>
                                                        <TableCell className={classes.tableHeaderCell}>Quotation Amount</TableCell>
                                                        <TableCell className={classes.tableHeaderCell}>Created At</TableCell>
                                                        <TableCell className={classes.tableHeaderCell}>Expected Closure Date</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {leadStatusData?.length > 0 ? (
                                                        leadStatusData
                                                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                            .map((row, i) => (
                                                                <TableRow key={i + 1}>
                                                                    <TableCell>{i + 1}</TableCell>
                                                                    <TableCell component="th" scope="row">
                                                                        <Link
                                                                            target="_blank"
                                                                            to={`/project-logs/${row?.leadId}`}
                                                                            style={{ color: '#000', textDecoration: 'underline' }}
                                                                        >
                                                                            {row?.customerName}
                                                                        </Link>
                                                                    </TableCell>
                                                                    <TableCell>{row?.lead_no}</TableCell>
                                                                    <TableCell>{row?.erpProjectNo}</TableCell>
                                                                    <TableCell>{row?.currentStage}</TableCell>
                                                                    <TableCell>{row?.email}</TableCell>
                                                                    <TableCell>{row?.contact_no}</TableCell>
                                                                    <TableCell>{row?.address}</TableCell>
                                                                    <TableCell>{row?.area}</TableCell>
                                                                    <TableCell>{row?.leadType}</TableCell>
                                                                    <TableCell>{row?.assignTo}</TableCell>
                                                                    <TableCell>₹ {row?.estimatedBudget}</TableCell>
                                                                    <TableCell>{row?.createdAt}</TableCell>
                                                                    <TableCell>{row?.expectedSalesclosureDate}</TableCell>
                                                                </TableRow>
                                                            ))
                                                    ) : (
                                                        <TableRow>
                                                            <TableCell colSpan={14} style={{ textAlign: 'center' }}>
                                                                No Records Found
                                                            </TableCell>
                                                        </TableRow>
                                                    )}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Paper>
                                </div>
                            )}
                        </Paper>
                    </>
                }
                {
                    props.role === ROLENAME.SalesUser && <>
                        {/* Status wise data for Log in Sales Executive */}
                        {/* <Paper className={classes.paper}>
                            <Accordion defaultExpanded>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography className={classes.heading}>*Please select the "Lead Created At" option to see meaningful data</Typography>
                                </AccordionSummary>
                                <Divider />
                                <AccordionDetails style={{ padding: 0 }}>
                                    <TableContainer component={Paper}>
                                        <Table className={classes.table} stickyHeader aria-label="sticky table">
                                            <TableHead>
                                                <TableRow >
                                                    <TableCell rowSpan={3} style={{ padding: 10, width: 500, textAlign: 'center', fontWeight: 700 }}>Sales Executive</TableCell>
                                                    <TableCell style={{ padding: 10, width: 500, textAlign: 'center', fontWeight: 700 }}>Lead Status</TableCell>
                                                    <TableCell style={{ padding: 10, width: 500, textAlign: 'center', fontWeight: 700 }}>Value</TableCell>
                                                    <TableCell style={{ padding: 10, width: 500, textAlign: 'center', fontWeight: 700 }}>Numbers</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    leadsOnSelectedDate.length !== 0 ?
                                                        leadsOnSelectedDate.map((row, i) => {
                                                            return (
                                                                <TableRow key={i + 1}>
                                                                    <TableCell component="th" scope="row" style={{ padding: 10, width: 500, textAlign: 'center' }}>
                                                                        {userDetails?.name}
                                                                    </TableCell>
                                                                    <TableCell component="th" scope="row" style={{ padding: 10, width: 500, textAlign: 'center' }}>
                                                                        {row.status}
                                                                    </TableCell>
                                                                    <TableCell component="th" scope="row" style={{ padding: 10, width: 500, textAlign: 'center' }}>
                                                                        ₹ {commaSeparateAmount(row.value)}
                                                                    </TableCell>
                                                                    <TableCell component="th" scope="row" style={{ padding: 10, width: 500, textAlign: 'center' }}>
                                                                        {
                                                                            canEdit === true && row.count !== 0 ?
                                                                                <Button onClick={() => changeSalesPageRoute(row)} color="primary">
                                                                                    {row.count !== 'undefined' || row.count !== '' ? row.count : `-`}
                                                                                </Button>
                                                                                :
                                                                                <> {row.count !== 'undefined' || row.count !== '' ? row.count : `-`} </>
                                                                        }
                                                                    </TableCell>
                                                                </TableRow>
                                                            );
                                                        })
                                                        :
                                                        <TableRow>
                                                            <TableCell style={{ textAlign: 'center' }}>No Data Found</TableCell>
                                                        </TableRow>
                                                }
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </AccordionDetails>
                            </Accordion>
                        </Paper> */}

                        {/* Stage Wise Data for Log in Sales Executive */}
                        <Paper className={classes.paper} style={{ marginTop: 20 }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                                <Typography variant="h6" className={classes.heading}>
                                    Stage-wise Data (No Date Filter)
                                </Typography>
                                <Button
                                    onClick={handleRefreshStageData}
                                    variant="contained"
                                    disabled={isStageDataTableDisabled}
                                    style={{ 
                                        backgroundColor: isStageDataTableDisabled ? "#cccccc" : "#F47E46", 
                                        color: "#FFFFFF",
                                        padding: "8px 16px"
                                    }}
                                    size="small"
                                >
                                    {isStageDataTableDisabled 
                                        ? `Wait (${formatStageDataTableTimeLeft()})` 
                                        : "Fetch New Data"}
                                </Button>
                            </div>
                            <Divider />
                            <TableContainer component={Paper}>
                                <Table className={classes.table} stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                            {stages.map((stage, index) => (
                                                <TableCell
                                                    key={index}
                                                    style={{
                                                        padding: 10,
                                                        width: 500,
                                                        textAlign: 'center',
                                                        fontWeight: 700,
                                                        backgroundColor: '#f0f8ff',
                                                        fontWeight: 'bold',
                                                    }}
                                                >
                                                    {stage}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {salesStageLeadOnSelectedDate.length !== 0 ? (
                                            salesStageLeadOnSelectedDate.map((row, i) => (
                                                <TableRow key={i + 1}>
                                                    {stages.map((stage) => (
                                                        <TableCell
                                                            key={stage}
                                                            component="th"
                                                            scope="row"
                                                            style={{ padding: 10, width: 500, textAlign: 'center' }}
                                                        >
                                                            <Button
                                                                onClick={() =>
                                                                    getLeadCountDetails(
                                                                        stage === 'Total' ? 'salesTotal' : stage,
                                                                        userDetails?._id,
                                                                        ""
                                                                    )
                                                                }
                                                                color="primary"
                                                            >
                                                                {row?.stages?.[stage] || '0'}
                                                            </Button>
                                                        </TableCell>
                                                    ))}
                                                </TableRow>
                                            ))
                                        ) : (
                                            <TableRow>
                                                <TableCell colSpan={stages.length} style={{ textAlign: 'center' }}>
                                                    No Data Found
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            {isStageDataVisible && leadStatusData.length > 0 && (
                                <div ref={dataTableRef} style={{ marginTop: 20, marginBottom: 20 }}>
                                    <Paper>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 20px', flexWrap: 'nowrap' }}>
                                            <Typography variant="h6" className={classes.heading} style={{ whiteSpace: 'nowrap' }}>
                                                Table View for Stage: {selectedStage} of {selectedUser}
                                            </Typography>
                                            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                                <Button
                                                    onClick={downloadExcel}
                                                    variant="contained"
                                                    color="primary"
                                                    startIcon={<GetAppIcon />}
                                                >
                                                    Download
                                                </Button>
                                                <Button
                                                    variant="contained"
                                                    color="secondary"
                                                    onClick={() => setIsStageDataVisible(false)}
                                                    startIcon={<CloseIcon />}
                                                >
                                                    Close
                                                </Button>
                                                <TablePagination
                                                    rowsPerPageOptions={[100, 200, 400, { label: 'All', value: leadStatusData?.length }]}
                                                    colSpan={14}
                                                    count={leadStatusData?.length}
                                                    rowsPerPage={rowsPerPage}
                                                    page={page}
                                                    SelectProps={{
                                                        inputProps: { 'aria-label': 'rows per page' },
                                                        native: true,
                                                    }}
                                                    onPageChange={handleChangePage}
                                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                                    style={{ flexShrink: 0 }}
                                                />
                                            </div>
                                            <CSVLink
                                                headers={headers}
                                                filename={selectedStage.replace(/-/g, ' ') + '.csv'}
                                                data={csvData}
                                                ref={buttonRef}
                                                style={{ display: 'none' }} // Keeps it functional but hidden
                                            />
                                        </div>
                                        <Divider />
                                        <TableContainer component={Paper}>
                                            <Table className={classes.table} stickyHeader aria-label="sticky table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell className={classes.tableHeaderCell}>Sl No.</TableCell>
                                                        <TableCell className={classes.tableHeaderCell}>Customer</TableCell>
                                                        <TableCell className={classes.tableHeaderCell}>Lead No</TableCell>
                                                        <TableCell className={classes.tableHeaderCell}>Project No.</TableCell>
                                                        <TableCell className={classes.tableHeaderCell}>Current Stage</TableCell>
                                                        <TableCell className={classes.tableHeaderCell}>Email</TableCell>
                                                        <TableCell className={classes.tableHeaderCell}>Mobile</TableCell>
                                                        <TableCell className={classes.tableHeaderCell}>Address</TableCell>
                                                        <TableCell className={classes.tableHeaderCell}>Area</TableCell>
                                                        <TableCell className={classes.tableHeaderCell}>Lead Type</TableCell>
                                                        <TableCell className={classes.tableHeaderCell}>Assigned to</TableCell>
                                                        <TableCell className={classes.tableHeaderCell}>Quotation Amount</TableCell>
                                                        <TableCell className={classes.tableHeaderCell}>Created At</TableCell>
                                                        <TableCell className={classes.tableHeaderCell}>Expected Closure Date</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {leadStatusData?.length > 0 ? (
                                                        leadStatusData
                                                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                            .map((row, i) => (
                                                                <TableRow key={i + 1}>
                                                                    <TableCell>{i + 1}</TableCell>
                                                                    <TableCell component="th" scope="row">
                                                                        <Link
                                                                            target='_blank'
                                                                            to={`/project-logs/${row?.leadId}`}
                                                                            style={{ color: '#000', textDecoration: 'underline' }}
                                                                        >
                                                                            {row?.customerName}
                                                                        </Link>
                                                                    </TableCell>
                                                                    <TableCell>{row?.lead_no}</TableCell>
                                                                    <TableCell>{row?.erpProjectNo}</TableCell>
                                                                    <TableCell>{row?.currentStage}</TableCell>
                                                                    <TableCell>{row?.email}</TableCell>
                                                                    <TableCell>{row?.contact_no}</TableCell>
                                                                    <TableCell>{row?.address}</TableCell>
                                                                    <TableCell>{row?.area}</TableCell>
                                                                    <TableCell>{row?.leadType}</TableCell>
                                                                    <TableCell>{row?.assignTo}</TableCell>
                                                                    <TableCell>₹ {row?.estimatedBudget}</TableCell>
                                                                    <TableCell>{row?.createdAt}</TableCell>
                                                                    <TableCell>{row?.expectedSalesclosureDate}</TableCell>
                                                                </TableRow>
                                                            ))
                                                    ) : (
                                                        <TableRow>
                                                            <TableCell colSpan={14} style={{ textAlign: 'center' }}>
                                                                No Records Found
                                                            </TableCell>
                                                        </TableRow>
                                                    )}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Paper>
                                </div>
                            )}
                        </Paper>
                    </>
                }
                {
                    ((props.role === ROLENAME.DGM_Sales) && (sortedData !== undefined) && (sortedData.length != 0) && (sortedData[0].length != 0)) &&

                    <>
                        <div>
                            <FormControl variant="outlined" style={{ margin: 10, width: "30%", marginRight: 50 }} className={classes.formControl}>
                                <InputLabel id="demo-simple-select-label">Experience Center</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-mutiple-checkbox"
                                    multiple
                                    value={selectedExpcenters}
                                    label="Exp-Center"
                                    onChange={getSelectedExpCenters}
                                    input={<Input />}
                                    renderValue={(selected) => selected.join(" ,")}
                                    MenuProps={MenuProps}
                                >
                                    {dumpExpCenters.map((name) => (
                                        <MenuItem key={name.name} value={name.name}>
                                            <Checkbox checked={selectedExpcenters.indexOf(name.name) > -1} />
                                            <ListItemText primary={name.name} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            {/* <FormControl variant="outlined" style={{ margin: 20, width: "30%" }} className={classes.formControl}>
                                <InputLabel id="demo-simple-select-label">Token Percentage</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="TokenPercentage"
                                    onChange={e => setTokenPercentage(e.target.value)}
                                    value={TokenPercentage}
                                >
                                    <MenuItem value={"Below-5%"}>Below 5%</MenuItem>
                                    <MenuItem value={"Above-5%"}>Above 5%</MenuItem>

                                </Select>
                            </FormControl> */}
                            <FormControlLabel
                                value="end"
                                control={<Switch color="primary" checked={checked} onChange={toggleChecked} />}
                                label="Token Above 5%"
                            />
                            {/* <Button style={{ margin: 20 }} variant="contained" color="secondary" onClick={applyFilter}> Filter</Button> */}
                            {/* <Button style={{ margin: 20 }} variant="contained" color="secondary" onClick={clearFilter}>Clear Filter</Button> */}

                        </div>
                        <div className={classes.tablecontainer}>

                            <div className={classes.tablealign}>
                                <TableContainer style={{ width: "100%" }} component={Paper}>
                                    <Table style={{ width: 400 }} className={classes.table} stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow >
                                                <TableCell component="th" scope="row" style={{ textAlign: 'center', height: 116 }}>Center Name</TableCell>
                                                <TableCell component="th" scope="row" style={{ textAlign: 'center', height: 116 }}>Name</TableCell>


                                            </TableRow>
                                        </TableHead>

                                        <TableBody>

                                            {sortedData.map((items, index) => {
                                                return (
                                                    <>
                                                        {
                                                            items.map((subItems, sIndex) => {
                                                                return (
                                                                    <TableRow >
                                                                        {index === 0 && <>
                                                                            <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{subItems.expcenter}</TableCell>
                                                                            <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{subItems.name}</TableCell>
                                                                        </>
                                                                        }

                                                                    </TableRow>
                                                                )
                                                            })
                                                        }

                                                    </>);
                                            })}
                                            <TableRow >
                                                <TableCell component="th" scope="row" style={{ textAlign: 'center' }} colSpan={2}>
                                                    <b>TOTAL (sum of managers)</b>
                                                </TableCell>

                                            </TableRow>

                                        </TableBody>

                                    </Table>
                                </TableContainer>
                            </div>
                            <div className={classes.tablealign}>
                                <TableContainer component={Paper}>
                                    <Table className={classes.table} stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow >
                                                <TableCell colspan={2} component="th" scope="row" style={{ textAlign: 'center' }}>{sortedData[0][0].month}</TableCell>
                                            </TableRow>
                                            <TableRow >
                                                <>
                                                    <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>Value</TableCell>
                                                    <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>Count</TableCell>

                                                </>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {sortedData[0].map((items, index) => {
                                                return (
                                                    <TableRow >
                                                        <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{items.totalValue}</TableCell>
                                                        <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{items.count}</TableCell>
                                                    </TableRow>
                                                )
                                            })
                                            }
                                            <TableRow>
                                                <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{totalCol[0].total}</TableCell>
                                                <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{totalCol[0].count}</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                            <div className={classes.tablealign}>
                                <TableContainer component={Paper}>
                                    <Table className={classes.table} stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow >
                                                <TableCell colspan={2} component="th" scope="row" style={{ textAlign: 'center' }}>{sortedData[1][0].month}</TableCell>
                                            </TableRow>
                                            <TableRow >
                                                <>
                                                    <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>Value</TableCell>
                                                    <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>Count</TableCell>

                                                </>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {sortedData[1].map((items, index) => {
                                                return (
                                                    <TableRow >
                                                        <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{items.totalValue}</TableCell>
                                                        <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{items.count}</TableCell>
                                                    </TableRow>
                                                )
                                            })
                                            }
                                            <TableRow>
                                                <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{totalCol[1].total}</TableCell>
                                                <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{totalCol[1].count}</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                            <div className={classes.tablealign}>
                                <TableContainer component={Paper}>
                                    <Table className={classes.table} stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow >
                                                <TableCell colspan={2} component="th" scope="row" style={{ textAlign: 'center' }}>{sortedData[2][0].month}</TableCell>
                                            </TableRow>
                                            <TableRow >
                                                <>
                                                    <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>Value</TableCell>
                                                    <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>Count</TableCell>

                                                </>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {sortedData[2].map((items, index) => {
                                                return (
                                                    <TableRow >
                                                        <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{items.totalValue}</TableCell>
                                                        <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{items.count}</TableCell>
                                                    </TableRow>
                                                )
                                            })
                                            }
                                            <TableRow>
                                                <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{totalCol[2].total}</TableCell>
                                                <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{totalCol[2].count}</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                            <div className={classes.tablealign}>
                                <TableContainer component={Paper}>
                                    <Table className={classes.table} stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow >
                                                <TableCell colspan={2} component="th" scope="row" style={{ textAlign: 'center' }}>{sortedData[3][0].month}</TableCell>
                                            </TableRow>
                                            <TableRow >
                                                <>
                                                    <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>Value</TableCell>
                                                    <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>Count</TableCell>

                                                </>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {sortedData[3].map((items, index) => {
                                                return (
                                                    <TableRow >
                                                        <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{items.totalValue}</TableCell>
                                                        <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{items.count}</TableCell>
                                                    </TableRow>
                                                )
                                            })
                                            }
                                            <TableRow>
                                                <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{totalCol[3].total}</TableCell>
                                                <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{totalCol[3].count}</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                            <div className={classes.tablealign}>
                                <TableContainer component={Paper}>
                                    <Table className={classes.table} stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow >
                                                <TableCell colspan={2} component="th" scope="row" style={{ textAlign: 'center' }}>{sortedData[4][0].month}</TableCell>
                                            </TableRow>
                                            <TableRow >
                                                <>
                                                    <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>Value</TableCell>
                                                    <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>Count</TableCell>

                                                </>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {sortedData[4].map((items, index) => {
                                                return (
                                                    <TableRow >
                                                        <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{items.totalValue}</TableCell>
                                                        <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{items.count}</TableCell>
                                                    </TableRow>
                                                )
                                            })
                                            }
                                            <TableRow>
                                                <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{totalCol[4].total}</TableCell>
                                                <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{totalCol[4].count}</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                            <div className={classes.tablealign}>
                                <TableContainer component={Paper}>
                                    <Table className={classes.table} stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow >
                                                <TableCell colspan={2} component="th" scope="row" style={{ textAlign: 'center' }}>{sortedData[5][0].month}</TableCell>
                                            </TableRow>
                                            <TableRow >
                                                <>
                                                    <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>Value</TableCell>
                                                    <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>Count</TableCell>

                                                </>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {sortedData[5].map((items, index) => {
                                                return (
                                                    <TableRow >
                                                        <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{items.totalValue}</TableCell>
                                                        <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{items.count}</TableCell>
                                                    </TableRow>
                                                )
                                            })
                                            }
                                            <TableRow>
                                                <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{totalCol[5].total}</TableCell>
                                                <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{totalCol[5].count}</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                            <div className={classes.tablealign}>
                                <TableContainer component={Paper}>
                                    <Table className={classes.table} stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow >
                                                <TableCell colspan={2} component="th" scope="row" style={{ textAlign: 'center' }}>{sortedData[6][0].month}</TableCell>
                                            </TableRow>
                                            <TableRow >
                                                <>
                                                    <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>Value</TableCell>
                                                    <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>Count</TableCell>

                                                </>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {sortedData[6].map((items, index) => {
                                                return (
                                                    <TableRow >
                                                        <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{items.totalValue}</TableCell>
                                                        <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{items.count}</TableCell>
                                                    </TableRow>
                                                )
                                            })
                                            }
                                            <TableRow>
                                                <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{totalCol[6].total}</TableCell>
                                                <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{totalCol[6].count}</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                            <div className={classes.tablealign}>
                                <TableContainer component={Paper}>
                                    <Table className={classes.table} stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow >
                                                <TableCell colspan={2} component="th" scope="row" style={{ textAlign: 'center' }}>{sortedData[7][0].month}</TableCell>
                                            </TableRow>
                                            <TableRow >
                                                <>
                                                    <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>Value</TableCell>
                                                    <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>Count</TableCell>

                                                </>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {sortedData[7].map((items, index) => {
                                                return (
                                                    <TableRow >
                                                        <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{items.totalValue}</TableCell>
                                                        <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{items.count}</TableCell>
                                                    </TableRow>
                                                )
                                            })
                                            }
                                            <TableRow>
                                                <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{totalCol[7].total}</TableCell>
                                                <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{totalCol[7].count}</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                            <div className={classes.tablealign}>
                                <TableContainer component={Paper}>
                                    <Table className={classes.table} stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow >
                                                <TableCell colspan={2} component="th" scope="row" style={{ textAlign: 'center' }}>{sortedData[8][0].month}</TableCell>
                                            </TableRow>
                                            <TableRow >
                                                <>
                                                    <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>Value</TableCell>
                                                    <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>Count</TableCell>

                                                </>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {sortedData[8].map((items, index) => {
                                                return (
                                                    <TableRow >
                                                        <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{items.totalValue}</TableCell>
                                                        <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{items.count}</TableCell>
                                                    </TableRow>
                                                )
                                            })
                                            }
                                            <TableRow>
                                                <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{totalCol[8].total}</TableCell>
                                                <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{totalCol[8].count}</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                            <div className={classes.tablealign}>
                                <TableContainer component={Paper}>
                                    <Table className={classes.table} stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow >
                                                <TableCell colspan={2} component="th" scope="row" style={{ textAlign: 'center' }}>{sortedData[9][0].month}</TableCell>
                                            </TableRow>
                                            <TableRow >
                                                <>
                                                    <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>Value</TableCell>
                                                    <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>Count</TableCell>

                                                </>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {sortedData[9].map((items, index) => {
                                                return (
                                                    <TableRow >
                                                        <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{items.totalValue}</TableCell>
                                                        <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{items.count}</TableCell>
                                                    </TableRow>
                                                )
                                            })
                                            }
                                            <TableRow>
                                                <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{totalCol[9].total}</TableCell>
                                                <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{totalCol[9].count}</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                            <div className={classes.tablealign}>
                                <TableContainer component={Paper}>
                                    <Table className={classes.table} stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow >
                                                <TableCell colspan={2} component="th" scope="row" style={{ textAlign: 'center' }}>{sortedData[10][0].month}</TableCell>
                                            </TableRow>
                                            <TableRow >
                                                <>
                                                    <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>Value</TableCell>
                                                    <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>Count</TableCell>

                                                </>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {sortedData[10].map((items, index) => {
                                                return (
                                                    <TableRow >
                                                        <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{items.totalValue}</TableCell>
                                                        <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{items.count}</TableCell>
                                                    </TableRow>
                                                )
                                            })
                                            }
                                            <TableRow>
                                                <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{totalCol[10].total}</TableCell>
                                                <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{totalCol[10].count}</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                            <div className={classes.tablealign}>
                                <TableContainer component={Paper}>
                                    <Table className={classes.table} stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow >
                                                <TableCell colspan={2} component="th" scope="row" style={{ textAlign: 'center' }}>{sortedData[11][0].month}</TableCell>
                                            </TableRow>
                                            <TableRow >
                                                <>
                                                    <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>Value</TableCell>
                                                    <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>Count</TableCell>

                                                </>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {sortedData[11].map((items, index) => {
                                                return (
                                                    <TableRow >
                                                        <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{items.totalValue}</TableCell>
                                                        <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{items.count}</TableCell>
                                                    </TableRow>
                                                )
                                            })
                                            }
                                            <TableRow>
                                                <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{totalCol[11].total}</TableCell>
                                                <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{totalCol[11].count}</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                            <div className={classes.tablealign}>
                                <TableContainer component={Paper}>
                                    <Table className={classes.table} stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow >
                                                <TableCell colspan={2} component="th" scope="row" style={{ textAlign: 'center' }}>{sortedData[12][0].month}</TableCell>
                                            </TableRow>
                                            <TableRow >
                                                <>
                                                    <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>Value</TableCell>
                                                    <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>Count</TableCell>

                                                </>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {sortedData[12].map((items, index) => {
                                                return (
                                                    <TableRow >
                                                        <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{items.totalValue}</TableCell>
                                                        <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{items.count}</TableCell>
                                                    </TableRow>
                                                )
                                            })
                                            }
                                            <TableRow>
                                                <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{totalCol[12].total}</TableCell>
                                                <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{totalCol[12].count}</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                            <div className={classes.tablealign}>
                                <TableContainer component={Paper}>
                                    <Table className={classes.table} stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow >
                                                <TableCell colspan={2} component="th" scope="row" style={{ textAlign: 'center' }}>Total</TableCell>
                                            </TableRow>
                                            <TableRow >
                                                <>
                                                    <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>Value</TableCell>
                                                    <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>Count</TableCell>

                                                </>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {rowTotal.map((items, index) => {
                                                return (
                                                    <TableRow >
                                                        <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{items.value}</TableCell>
                                                        <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{items.count}</TableCell>
                                                    </TableRow>
                                                )
                                            })
                                            }
                                            <TableRow>
                                                <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{totalCol[13].total}</TableCell>
                                                <TableCell component="th" scope="row" style={{ textAlign: 'center' }}>{totalCol[13].count}</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>

                        </div>
                    </>

                }
            </div>
        </div>
    )
}

export default connect(null, { setLoading, setSnackInfo })(CalenderFilterData)
